const claimBonusSkeletonStyles = {
    outerContainer: `flex flex-col gap-2`,
    skeleton: `min-h-[60px] bg-themeOverlay rounded-[10px] w-[98%] animate-pulse`
}

export { claimBonusSkeletonStyles }